const getters = {};

getters.coordinates = state => state.coordinates;
getters.locations = state => state.locations;
getters.numberOfPages = state => state.numberOfPages;
getters.currentPage = state => state.page;
getters.total = state => state.total;

export default getters;



// WEBPACK FOOTER //
// ./src/screens/Locations/store/getters.js